import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import * as THREE from 'three'
import { applyGems } from '../../../trillion-common/src/gems/applyGems'
import { Box3, Vector3, WebGLRenderer } from 'three'
import {
  getEnvironmentHelper,
  IEnvironmentHelper,
} from '../../../trillion-common/src/materials/environment'
import { updateAllMaterials } from '../../../trillion-common/src/materials/materials'
import { JewelryTypeName } from '../../../trillion-common/src/typings/jewelry-type'
import { hideTargetObjects } from '../../../trillion-common/src/utils/loadObjectsHelper'
import { gems } from './gemsConfigs'

const DISTANCE_BETWEEN_EARRINGS = 0.5
const dracoDecoderPath = 'https://cdn.jsdelivr.net/npm/three@0.146/examples/js/libs/draco/gltf/'

export const loadingManager = new THREE.LoadingManager()
const gltfLoader = new GLTFLoader(loadingManager)
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath(dracoDecoderPath)
gltfLoader.setDRACOLoader(dracoLoader)

export async function setupGLTFJewel(
  jewelryPath: string,
  jewelryType: JewelryTypeName,
  renderer: WebGLRenderer,
  cancelMirroring?: boolean,
): Promise<THREE.Group> {
  const environmentHelper = getEnvironmentHelper(renderer)
  const jewel = await gltfLoader.loadAsync(jewelryPath)

  const rezGroup = new THREE.Group()
  rezGroup.add(await setupScene(jewel.scene, environmentHelper))

  rezGroup.animations = jewel.animations

  if (jewelryType === 'earrings') {
    rezGroup.add(cloneEarring(jewel, cancelMirroring))
  }

  return rezGroup
}

function cloneEarring(jewel: GLTF, cancelMirroring?: boolean) {
  const secondEarring = jewel.scene.clone()
  const box = new Box3().setFromObject(secondEarring)
  const size = box.getSize(new Vector3())
  const delta = Math.max(size.x * DISTANCE_BETWEEN_EARRINGS, 0.2)
  secondEarring.translateX(delta * 2)

  if (!cancelMirroring) {
    secondEarring.scale.multiply(new THREE.Vector3(-1, 1, 1))
  }

  secondEarring.translateY(-delta * 1.5)

  return secondEarring
}

async function setupScene(scene: THREE.Group, environmentHelper: IEnvironmentHelper) {
  updateAllMaterials(scene, environmentHelper)
  hideTargetObjects(scene, ['#chain-widget'])
  scene.castShadow = true
  scene.receiveShadow = true

  // remove shadow and occluder meshes
  scene.children
    .filter(
      (e) => e.name.toLowerCase().includes('#occluder') || e.name.toLowerCase().includes('#shadow'),
    )
    .forEach((e) => scene.remove(e))

  await applyGems(scene, gems)
  return scene
}
